import React from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { SEO } from '../../../../components/Seo/seo'
import { FormattedMessage, useIntl } from 'react-intl'
import Layout from '../../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../../routes'
import { editService } from '../../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { ServiceProvider } from '../../../../ServiceContext'
import { FormLoader } from '../../../../components/Loader/FormLoader'
import ServiceEditContent from '../../../../components/Dashboard/Subscription/ServiceEditContent'


const SingleServiceEdit = () => {
  let { id } = useParams()
  const intl = useIntl()
  return (
    <>
      {!!id && !!parseInt(id) ? <>
          <SEO title={intl.formatMessage({ id: 'Services.List.EditService.Title' })}
               pathname={window.location.origin}
               titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
               image={editService.image}
               description={intl.formatMessage({ id: 'Services.List.EditService.Title' })}
          />
          <AuthenticatedUserConsumer>
            {({ userDataLoading, userData, handleNotificationCall }) => (
              <>
                {!!userDataLoading && <FormLoader loading={true}/>}
                {!!Object.keys(userData).length &&
                <>
                  {!!userData.is_admin ? <Layout content={
                    <ServiceProvider pageAction={'edit'} sid={id}
                                     handleNotificationCall={handleNotificationCall}>
                      <ServiceEditContent pageTitle={<FormattedMessage id='Services.List.EditService.Title'/>}/>
                    </ServiceProvider>
                  }/> : (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
                  }
                </>
                }
              </>
            )}
          </AuthenticatedUserConsumer>
        </> :
        <Redirect to={NamedRoutes.subscription.service.list}/>
      }
    </>
  )
}

export default SingleServiceEdit

